







































































import { pick } from 'lodash';
import Vue from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    data: {
      type: Object as () => QuizResponse,
      required: true,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    toForm(quiz: QuizResponse) {
      const form = pick(quiz, [
        'passed_title',
        'passed_description',
        'failed_title',
        'failed_description',
        'neutral_title',
        'neutral_description',
        'is_gradable',
      ]);
      return form;
    },
    formToModel(form) {
      return { ...form };
    },
    async save() {
      try {
        await this.$store.dispatch('quiz/updateQuiz', {
          id: this.data.id,
          data: this.form,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(
            error.response,
            `${this.$t(
              'QUIZZES.NOTIFICATIONS.FAILED_TO_UPDATE_QUIZ'
            )}: ${error}`
          ),
          duration: -1,
        });
      } finally {
        this.$refs.form?.reset();
      }
    },
  },
  created() {
    this.form = this.toForm(this.data);
  },
});
